import { isEmpty } from "lodash";

export function addRule(data) {
    let errors = {}

    if (!data.ota_type) {
        errors.ota_type = 'Please select Upgrade type.'
    }

    if (!data.from_version) {
        if (data.ota_type === 'versioning') {
            errors.from_version = 'Please select Current Version.'
        } else if (data.ota_type === 'series_type') {
            errors.from_version = 'Please select series type.'
        } else if (data.ota_type === 'tag') {
            errors.from_version = 'Please select tag.'
        }
    }

    if (!data.to) {
        errors.to = 'Please select Upgrade Version.'
    }

    if (!data.name) {
        errors.name = 'Name is required.'
    }

    return {
        isValid: isEmpty(errors),
        errors
    }
}